import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import styled from 'styled-components';
import ProgressCircle from './ProgressCircle';
import ModalConfirm from './ModalConfirm';
import { getTextFromHtml } from '../../../utils/helper';

const Image = styled.span`
  width: 150px;
  height: 100px;
  background-size: cover;
  background-position: center center;
`;

const Text = styled.span`
  width: 100%;
  height: 100px;
  margin: 0 20px;
  color: #000;

  > span:first-child {
    display: block;
    font-size: 120%;
    font-weight: 700;
  }

  .description {
    height: 65px;
    margin-right: 10px;
    display: block;
    overflow: hidden;
  }

  .description + span {
    display: block;
    color: #bbb;
    font-size: 80%;
  }
`;

const Percent = styled.span`
  height: 40px;
  min-width: 40px;
  font-size: 10px;
  border-radius: 100%;

  box-shadow: 0 0 0 0 rgba(255,0,0,1);
  @keyframes pulse-red {
    0% { box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7); }
    70% { box-shadow: 0 0 0 10px rgba(255, 0, 0, 0); }
    100% { box-shadow: 0 0 0 0 rgba(255, 0, 0, 0); }
  }
`;

const Indicator = styled.span`
  height: 40px;
  width: 40px;
  font-size: 10px;
  display: block;

  span {
    display: block;
    height: 14px;
    width: 14px;
    background-color: red;
    border-radius: 100%;
    text-align: center;
    color: #fff;
    float: right;
  }
`;

export default ({
  id,
  title,
  description,
  training_status,
  file_link,
  priority,
  show_pulse,
  show_badge,
  completed_percent,
  correct_percent,
  due_date,
  interview,
  priorities,
  statusesIntl,
  update,
  page,
  limit,
  all_in_one_tab,
}) => {
  const [isInterviewed, setIsInterviewed] = useState(interview);
  const [isModalShowed, setIsModalShowed] = useState(false);
  const timeAllowed = due_date
    ? moment.duration(moment(due_date).diff()).days()
    : 0;

  return (
    <Link
      to={`/trainings/mytrainings/${id}/lessons`}
      className="courses-lesson"
      onClick={(ev) => {
        if (!isInterviewed) {
          ev.preventDefault();
          setIsModalShowed(true);
        }
      }}
      target={all_in_one_tab ? "_self" : "_blank"}
    >
      {isModalShowed && (
        <ModalConfirm
          id={id}
          onSuccess={() => {
            setIsModalShowed(false);
            setIsInterviewed(true);
            update({
              limit,
              ...(page === 1 ? {} : { offset: (page - 1) * limit }),
            });
          }}
          onBack={() => setIsModalShowed(false)}
        />
      )}
      <Image style={{ backgroundImage: `url(${file_link}?w=300&h=300)` }} />
      <Text style={{ alignSelf: "flex-start" }}>
        <span>{getTextFromHtml(title)}</span>
        <span
          className="description">{description || ''}</span>
        <span>
          <FormattedMessage
            id="mytrainings_training_priority"
            values={{ value: priorities[priority] || '' }}
          />{' '}
          <FormattedMessage id={statusesIntl[training_status]} />{' '}
          {!!due_date && (
            <FormattedMessage
              id="mytrainings_training_timeAllowed"
              values={{ value: timeAllowed }}
            />
          )}
        </span>
      </Text>
      <Percent
        style={
          show_pulse && !show_badge
            ? { animation: 'pulse-red 2s infinite' }
            : {}
        }
      >
        {!show_badge ? (
          <ProgressCircle
            completed={
              completed_percent === 70 && isInterviewed
                ? completed_percent + 10
                : completed_percent
            }
            correct={correct_percent}
          />
        ) : (
          <Indicator>
            <span>{priorities[priority]}</span>
          </Indicator>
        )}
      </Percent>
    </Link>
  );
};



// WEBPACK FOOTER //
// ./src/views/_MyTrainings/List/ListItem.js